import React from 'react'
import type { SetOptional } from 'type-fest'

import { env } from '@/config/env'
import { gaEvents } from '@/utils/ga-events'
import { useCurrentUserProfile } from '@/utils/user'

import {
  GradientGatsbyLink,
  GradientGatsbyLinkProps,
  GradientLink,
  GradientLinkProps,
} from '../header/gradient-button'

export type CreateAccountLinkProps = SetOptional<GradientLinkProps, 'href'>

export const CreateAccountLink: React.FC<CreateAccountLinkProps> = (props) => {
  const { children = 'Create Account', ...other } = props

  return (
    <GradientLink {...other} href={env.GIPHY_LOGIN_URL}>
      {children}
    </GradientLink>
  )
}

export type ReadDocsLinkProps = SetOptional<GradientGatsbyLinkProps, 'to'>

export const ReadDocsLink: React.FC<ReadDocsLinkProps> = (props) => {
  const { children = 'Read the Docs', ...other } = props

  return (
    <GradientGatsbyLink to="/docs/sdk" {...other}>
      {children}
    </GradientGatsbyLink>
  )
}

export type PrimaryHeaderCTAProps = {
  CreateAccountLinkProps?: CreateAccountLinkProps
  ReadDocsLinkProps?: ReadDocsLinkProps
}

export const PrimaryHeaderCTA: React.FC<PrimaryHeaderCTAProps> = (props) => {
  const { CreateAccountLinkProps, ReadDocsLinkProps } = props
  const userProfile = useCurrentUserProfile()

  return userProfile.data ? (
    <ReadDocsLink onClick={gaEvents.readDocsNav} {...ReadDocsLinkProps} />
  ) : (
    <CreateAccountLink onClick={gaEvents.createAccountNav} {...CreateAccountLinkProps} />
  )
}

export type PrimaryBodyCTAProps = {
  CreateAccountButtonProps?: CreateAccountLinkProps
  ReadDocsButtonProps?: ReadDocsLinkProps
}

export const PrimaryBodyCTA: React.FC<PrimaryBodyCTAProps> = (props) => {
  const { CreateAccountButtonProps, ReadDocsButtonProps } = props
  const userProfile = useCurrentUserProfile()

  return userProfile.data ? (
    <ReadDocsLink onClick={gaEvents.readDocsBody} {...ReadDocsButtonProps} />
  ) : (
    <CreateAccountLink onClick={gaEvents.createAccountBody} {...CreateAccountButtonProps} />
  )
}

export const MobilePrimaryHeaderCTA = PrimaryHeaderCTA

export const MobilePrimaryBodyCTA = PrimaryBodyCTA
